import { Listing } from './listing.type';

export const getAmenities = (
    listing: Pick<Listing, 'features'>
): { [key: string]: number } => {
    const features = {
        bedrooms: 0,
        bathrooms: 0,
        livingRooms: 0
    };

    for (const feature of listing.features || []) {
        const { content, iconId } = feature || {};

        if (!content || !iconId) continue;

        if (iconId === 'bed') features.bedrooms = content;
        if (iconId === 'bath') features.bathrooms = content;
        if (iconId === 'chair') features.livingRooms = content;
    }

    return features;
};
